<script setup>
import { onMounted } from "vue";
import {useRouter} from "vue-router";
import { getDatabase, ref as dbRef, set } from 'firebase/database';
import { getAuth, signOut } from 'firebase/auth';
const router = useRouter();
const auth = getAuth();
const database = getDatabase();

onMounted(async () => {
  const user = auth.currentUser;
  if (user) {
    const presenceRef = dbRef(database, `presence/${user.uid}`);
    await set(presenceRef, {
      state: 'offline',
      last_changed: Date.now(),
    });
    await signOut(auth);
    localStorage.clear();
    await router.push({path: "/signin"});
  }
});
</script>
